import { LinkedDestinationEntitlement } from '@css-xp/graphtypes/src/generated-types-new';
import { sentenceCase } from '@atlassian/cssxp-utils-generic';
import { BillEstimateOrderItemDto } from '@css-xp/common-services/src/api/gateways/ccp-gateways/src/ccp-api-order';
import { getBillPeriod } from '../../../utils/get-bill-period';
import { formatToUSD } from '../utils/currency-display';

export const copyReviewChangeContent = (data: any) => {
  const {
    selectedEntitlement,
    linkedEntitlements,
    billDate,
    grandTotal,
    linkedEntitlementsBillEstimate,
    currentEntitlementBillEstimate,
  } = data;

  const userTier = selectedEntitlement.userTier ? `User tier: ${selectedEntitlement.userTier}` : '';
  const units = selectedEntitlement.units ? `Units: ${selectedEntitlement.units}` : '';

  const priceText = `\nPrice: ${formatToUSD(currentEntitlementBillEstimate?.grandTotal ?? 0)}`;
  const currentBillPeriod = getBillPeriod(currentEntitlementBillEstimate?.items);
  const currentBillPeriodText = currentBillPeriod ? `\nBilling period: ${currentBillPeriod}` : '';

  const billDateSection = billDate ? `Bill date\n${billDate}\n\n` : '';
  let linkedEntitlementsSection = '';

  if (linkedEntitlements?.length > 0) {
    const linkedEntitlementsDetails = `${linkedEntitlements.map((item: LinkedDestinationEntitlement) => {
      const itemEstimate = linkedEntitlementsBillEstimate?.find(
        (billItem: BillEstimateOrderItemDto) => billItem?.entitlementId === item.entitlementId
      );

      const linkedBillPeriod = getBillPeriod(itemEstimate?.items);
      const linkedBillPeriodText = linkedBillPeriod ? `\nBilling period: ${linkedBillPeriod}` : '';
      const linkedUserTierText = item.userTier ? `\nUser tier: ${item.userTier}` : '';

      return `${item.productName}\n${item.entitlementNumber}\nBilling Cycle: ${sentenceCase(
        selectedEntitlement.billingFrequency
      )}\nPlan: ${item.edition}\nPrice: ${formatToUSD(
        itemEstimate?.grandTotal ?? 0
      )}${linkedBillPeriodText}${linkedUserTierText}\n\n`;
    })}`.replace(',', '');

    linkedEntitlementsSection = `Affected product family\n${linkedEntitlementsDetails}\n`;
  }

  const copyReviewChangeContentTemplate = `Hi,\nWe’ve received your request to change the billing cycle for your subscription from ${
    selectedEntitlement.isCurrentEntitlementFree ? 'Free' : 'Monthly'
  } to Annual. See the breakdown below for the amount you’ll be charged – this includes taxes and discounts, promotions or credits.\n\nDetails\nSubscription\n${
    selectedEntitlement.productName
  } ${selectedEntitlement.entitlementNumber}\nBilling Cycle: ${sentenceCase(
    selectedEntitlement.billingFrequency
  )}\nPlan: ${
    selectedEntitlement.pricingPlan
  }${priceText}${currentBillPeriodText}\n${userTier}${units}\n\n${linkedEntitlementsSection}Annual payment\n${formatToUSD(
    grandTotal ?? 0
  )}\n\n${billDateSection}Before you continue\nYou’ll need to confirm your acceptance of the adjusted charges, and agree to the Atlassian Cloud Terms of Service and Privacy Policy.\n\nOnce you accept, we’ll automatically renew your subscription. We’ll also advise you each year when your payment’s due, and charge your chosen payment method.\n\nChanged your mind?\nIf you don’t want to be charged, don’t worry – you don’t need to do anything.\n\nThanks,\nAtlassian Support`;

  navigator.clipboard.writeText(copyReviewChangeContentTemplate);
};
